import {Component} from '@angular/core';
import {AlertController, NavParams, ViewController} from 'ionic-angular';

import {ContratoService} from '../../../providers/contrato-service';
import {AlertService} from '../../../providers/alert-service';

@Component({
    selector: 'page-modal-pagamentos',
    templateUrl: 'modal-pagamentos.html',
    providers: [
        ContratoService
    ]
})
export class ModalPagamentosPage {
    listaDados: any;
    loading: boolean = true;
    cdModulo: any;
    titulo: any;
    objetoRetorno: {
        flag: boolean,
        objeto: string
    };
    jurisdicionado: any;
    pageListaContratos: number = 1;
    pagamentos: any = [];
    contratos: any = [];

    order: string = 'nmContrato';
    reverse: boolean = false;

    constructor(public alertCtrl: AlertController,
        private alertService: AlertService,
        private viewCtrl: ViewController,
        public navParams: NavParams,
        public contratoService: ContratoService) {

        this.objetoRetorno = {
            flag: false,
            objeto: ""
        };

        this.titulo = this.navParams.get('param1');
        this.pagamentos = this.navParams.get('pagamentos');

        // this.carregarDados();

        this.loading = false;
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }

        this.order = value;
    }

    // carregarDados() {

    //     let count = 0;

    //     this.contratosString.forEach(contrato => {
    //         this.contratoService.obterPorNumeroContrato(contrato).subscribe(data => {
    //             //this.contratoService.obterPorNumeroContrato(contrato).toPromise().then(data => {
    //             if (data != null && data != undefined) {
    //                 this.contratos.push(data);
    //             }
    //         }, error => {
    //             console.log("erro: " + error);
    //         });
    //     });

    //     setTimeout(() => {
    //         this.loading = false;
    //     }, 15000);
    // }

    // showTimeout() {
    //     this.loading = false;
    // }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    dismiss() {
        this.objetoRetorno.flag = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 20;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 20;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }
}




// WEBPACK FOOTER //
// ./src/pages/modais/modal-pagamentos/modal-pagamentos.ts